import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  timePeriodSelector: {
    marginTop: theme.spacing(1),
  },
}));

export default useStyles;
